'use client'

import { reopenConsentBanner } from '@/lib/consent-manager'

/**
 * Cookie settings for an /ar page footer. /ar renders no marketing chrome,
 * so the site footer's own button is not on the page; this is the same call
 * the site footer and /ar/radar (through RadarArabicBridge) make.
 */
export default function ArabicCookieButton() {
  return (
    <button type='button' onClick={reopenConsentBanner}>
      {'إعدادات ملفات تعريف الارتباط'}
    </button>
  )
}
